<alert [nom]="NOM_ALERTE_ERREUR_GENERALE" class="alerte" nomBouton="GLOBAL.OUI"></alert>

@if (loading) {
	<div class="spinner">
		<div class="app-spinner"></div>
	</div>
} @else {
	<div class="contenu-tab-equipe">
		<div class="form-equipe">
			<div class="input-container modification-nom-equipe">
				<label for="nom-equipe">{{ 'EQUIPE.LABEL_INPUT_NOM_EQUIPE' | translate }}</label>
				<div class="input-button">
					<div class="input-equipe input-nom-equipe">
						<input
								type="text"
								pInputText
								id="nom-equipe"
								aria-describedby="nom-equipe"
								[(ngModel)]="nomEquipe"
								[disabled]="!saisieNomEquipe()"
						/>
					</div>
					<div class="button-nom-equipe">
						@if (!this.saisieNomEquipe()) {
							<div class="button-saisir-nom-equipe">
								<p-button
										(onClick)="activerDesactiverSaisiNomEquipe()"
										icon="pi pi-pencil"
										[loading]="loadingModifierEquipe()"/>
							</div>
						} @else {
							<div class="button-valider-annuler">
								<p-button
										class="button-creer-modifier-equipe"
										(onClick)="creerModifierEquipe()"
										icon="pi pi-check"
										[disabled]="isButtonModifierNomEquipeDisabled()"
										[loading]="loadingModifierEquipe()"></p-button>
								<p-button
										(onClick)="activerDesactiverSaisiNomEquipe()"
										icon="pi pi-times"></p-button>
							</div>
						}
					</div>
				</div>
			</div>
			@if (isNotNullOrUndefined(equipe.id)) {
				<app-ajout-utilisateur
						[typeEntity]="'equipe'"
						[entityGestionEquipe]="equipe"
						[(utilisateurAAjouter)]="utilisateurAAjouter"
						(utilisateursTrouves)="utilisateursSuggestions = $event"
						[labelBouttonAjouter]="'EQUIPE.BUTTON_AJOUTER' | translate"
						(ajouterUtilisateur)="ajouterUtilisateur(false)"
						(retirerUtilisateurs)="retirerUtilisateurs()"
						[(utilisateursSelectionnes)]="utilisateursSelectionnes"/>
			}
		</div>
		<div class="parametre-equipe">
			@if (isNotNullOrUndefined(equipe.id)) {
				<app-gestion-zones-autorisees [zonesAutorisees]="this.equipe.zonesDeTravailAutorisees" (onAjoutRetraitZonesAutorisees)="onAjoutRetraitZones($event)"/>
			}
		</div>
	</div>

	<confirmation-modal-component/>
}
